import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "berulia_cookie_consent";

export function getCookieConsent() {
  try {
    return localStorage.getItem(STORAGE_KEY); // "accepted" | "refused" | null
  } catch {
    return null;
  }
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getCookieConsent()) setVisible(true);
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch {}
    setVisible(false);
    window.dispatchEvent(new CustomEvent("berulia:cookie-consent", { detail: value }));
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] bg-white/95 backdrop-blur border-t border-berulia-border shadow-[0_-4px_24px_rgba(0,0,0,0.06)]"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-3 md:py-4 flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-6">
        <p className="text-xs md:text-sm text-berulia-inkdeep leading-snug flex-1">
          BERULIA utilise des cookies pour mesurer l'audience du site et améliorer votre expérience.{" "}
          <Link to="/mentions-legales" className="underline hover:text-berulia-rosedeep whitespace-nowrap">
            En savoir plus
          </Link>
        </p>
        <div className="flex gap-2 w-full md:w-auto">
          <button
            type="button"
            onClick={() => decide("refused")}
            data-testid="cookie-refuse"
            className="flex-1 md:flex-none overline text-xs px-4 py-2 border border-berulia-border hover:border-berulia-inkdeep transition"
          >
            Refuser
          </button>
          <button
            type="button"
            onClick={() => decide("accepted")}
            data-testid="cookie-accept"
            className="flex-1 md:flex-none overline text-xs px-4 py-2 bg-berulia-rosedeep text-berulia-inkdeep hover:bg-berulia-rose transition"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
